<template>
  <li class="nav-item align-self-center cursor-pointer">
    <div @click="toggleMode">
      <i class="mdi mdi_icon mdi-24px mdi-theme-light-dark mr-1"/>
      {{ btnText }}
    </div>
  </li>
</template>
<script>
import {BaseButton, BaseSwitch} from 'src/components';
import {Switch} from "element-ui";

export default {
  name: 'theme-switch',
  components: {
    BaseButton,
    BaseSwitch,
    [Switch.name]: Switch,
  },
  computed: {
    darkMode() {
      return this.$store.state.app.darkMode
    },
    btnText() {
      if (this.$store.state.app.darkMode) {
        return this.$t("app.lightMode")
      }
      return this.$t("app.darkMode")

    }
  },
  methods: {
    toggleMode() {
      this.$store.dispatch('SetDarkMode', !this.darkMode)
    },
  }
};
</script>
